// extracted by mini-css-extract-plugin
module.exports = {"container":"feature-carousel_container__sV2GV","slide":"feature-carousel_slide__dfv_L"};